import { render } from "./ShareScreenSession.vue?vue&type=template&id=14958bde"
import script from "./ShareScreenSession.vue?vue&type=script&lang=js"
export * from "./ShareScreenSession.vue?vue&type=script&lang=js"

import "./ShareScreenSession.vue?vue&type=style&index=0&id=14958bde&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__